export const angleLayerDefinition = {
    geometryType: 'esriGeometryPoint',
    objectIdField: 'uniqueId',
    extent: {
        xmin: -180,
        ymin: -57.36978999600001,
        xmax: 180,
        ymax: 90,
        spatialReference: {
            wkid: 7844,
            latestWkid: 7844
        }
    },
    fields: [
        {
            name: 'objectid',
            type: 'esriFieldTypeOID',
            alias: 'objectid',
            editable: false,
            nullable: false
        },
        {
            name: 'guid',
            type: 'esriFieldTypeString',
            alias: 'guid',
            editable: true,
            nullable: false,
            length: 50
        },
        {
            name: 'id',
            type: 'esriFieldTypeInteger',
            alias: 'id',
            editable: true,
            nullable: false
        },
        {
            name: 'type',
            type: 'esriFieldTypeInteger',
            alias: 'type',
            editable: true,
            nullable: true
        },
        {
            name: 'anglefromlineid',
            type: 'esriFieldTypeInteger',
            alias: 'anglefromlineid',
            editable: true,
            nullable: true
        },
        {
            name: 'angletolineid',
            type: 'esriFieldTypeInteger',
            alias: 'angletolineid',
            editable: true,
            nullable: true
        },
        {
            name: 'measurementsource',
            type: 'esriFieldTypeString',
            alias: 'measurementsource',
            nullable: true,
            editable: true,
            length: 50
        },
        {
            name: 'pointid',
            type: 'esriFieldTypeInteger',
            alias: 'pointid',
            editable: true,
            nullable: true
        },
        {
            name: 'anglemeasurementsource',
            type: 'esriFieldTypeInteger',
            alias: 'anglemeasurementsource',
            editable: true,
            nullable: true
        },
        {
            name: 'anglederivation',
            type: 'esriFieldTypeString',
            alias: 'anglederivation',
            editable: true,
            nullable: true,
            length: 50
        },
        {
            name: 'legacyangacc',
            type: 'esriFieldTypeString',
            alias: 'legacyangacc',
            editable: true,
            nullable: true,
            length: 50
        },
        {
            name: 'x',
            type: 'esriFieldTypeDouble',
            alias: 'x',
            editable: true,
            nullable: true
        },
        {
            name: 'y',
            type: 'esriFieldTypeDouble',
            alias: 'y',
            editable: true,
            nullable: true
        },
        {
            name: 'z',
            type: 'esriFieldTypeDouble',
            alias: 'z',
            editable: true,
            nullable: true
        },
        {
            name: 'importlayername',
            type: 'esriFieldTypeInteger',
            alias: 'importlayername',
            editable: true,
            nullable: true
        },
        {
            name: 'anglerotation',
            type: 'esriFieldTypeDouble',
            alias: 'anglerotation',
            editable: true,
            nullable: true
        },
        {
            name: 'legacylocalangleno',
            type: 'esriFieldTypeString',
            alias: 'legacylocalangleno',
            editable: true,
            nullable: true,
            length: 50
        },
        {
            name: 'legacylocalpointno',
            type: 'esriFieldTypeInteger',
            alias: 'legacylocalpointno',
            editable: true,
            nullable: true
        },
        {
            name: 'importfilename',
            type: 'esriFieldTypeString',
            alias: 'importfilename',
            editable: true,
            nullable: true,
            length: 255
        },
        {
            name: 'legacyrecordid',
            type: 'esriFieldTypeInteger',
            alias: 'legacyrecordid',
            editable: true,
            nullable: true
        },
        {
            name: 'origx',
            type: 'esriFieldTypeDouble',
            alias: 'origx',
            editable: true,
            nullable: true
        },
        {
            name: 'origy',
            type: 'esriFieldTypeDouble',
            alias: 'origy',
            editable: true,
            nullable: true
        },
        {
            name: 'enlargementid',
            type: 'esriFieldTypeInteger',
            alias: 'enlargementid',
            editable: true,
            nullable: true
        },
        {
            name: 'enlargementids',
            type: 'esriFieldTypeString',
            alias: 'enlargementids',
            editable: true,
            nullable: true,
            length: 1024
        },
        {
            name: 'parentid',
            type: 'esriFieldTypeInteger',
            alias: 'parentid',
            editable: true,
            nullable: true
        },
        {
            name: 'internalangle',
            type: 'esriFieldTypeString',
            alias: 'internalangle',
            editable: true,
            nullable: true,
            length: 50
        },
        {
            name: 'angleaccuracy',
            type: 'esriFieldTypeSmallInteger',
            alias: 'angleaccuracy',
            editable: true,
            nullable: true
        },
        {
            name: 'legacyangval',
            type: 'esriFieldTypeString',
            alias: 'legacyangval',
            editable: true,
            nullable: true,
            length: 50
        },
        {
            name: 'legacyfromlineid',
            type: 'esriFieldTypeInteger',
            alias: 'legacyfromlineid',
            editable: true,
            nullable: true
        },
        {
            name: 'legacytolineid',
            type: 'esriFieldTypeInteger',
            alias: 'legacytolineid',
            editable: true,
            nullable: true
        },
        {
            name: 'visible',
            type: 'esriFieldTypeString',
            alias: 'visible',
            editable: true,
            nullable: true,
            length: 5
        },
        {
            name: 'hiddenonenlargements',
            type: 'esriFieldTypeString',
            alias: 'hiddenOnEnlargements',
            editable: true,
            nullable: true,
            length: 1024
        },
        {
            name: 'anglerotationdms',
            type: 'esriFieldTypeString',
            alias: 'anglerotationdms',
            editable: true,
            nullable: true,
            length: 50
        },
        {
            name: 'labelproperties',
            type: 'esriFieldTypeString',
            alias: 'labelproperties',
            editable: true,
            nullable: true,
            length: 1024
        }
    ]
};
